import { Configuration, LogLevel } from '@azure/msal-browser'
import { authConfig } from './authMode'

const { azureClientId: clientId, azureTenantId: tenantId, redirectUri } = authConfig

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
}

export const loginRequest = {
  scopes: clientId ? [`api://${clientId}/access_as_user`] : [],
}

export const apiScopes = {
  scopes: clientId ? [`api://${clientId}/access_as_user`] : [],
}
